import Lexer from './Lexer';
import Parser from './Parser';

export enum LexemeType {
  TEXT = '',
  BOLD = 'strong',
  ITALIC = 'em',
  DASHED = 'del',
  CODE = 'pre'
}

export interface Lexeme {
  type: LexemeType;
  token: string;
}

export const LINK_REGEX = /(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;

export function parse(text: string): string {
  const links = text.match(LINK_REGEX);

  links?.forEach((link, idx) => {
    text = text.replace(link, `[LINK_${idx}]`);
  });
  
  const lexer = new Lexer(text);
  const parser = new Parser(lexer);
  const parsed = parser.parse();

  return links ? links.reduce((text, link, idx) => {
    return text.replace(`[LINK_${idx}]`, `<a href="${link}" target="_blank">${link}</a>`);
  }, parsed) : parsed;
};

export default parse;